import React from "react";
import GeneralError from "../GeneralError";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // You can send error info to a logging service here
    // console.error("Uncaught error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return <GeneralError error={this.state.error} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
